import React, { useEffect, useState } from 'react'
import { useFetch, usePost, useCurrent, useDelete, usePut } from '../../hooks';
import { MwSpinner, ConfirmDelete } from '../../components/ui';
import CreatePaymentMethod from '../../components/payment/CreatePaymentMethod';
import PaymentMethodList from '../../components/payment/PaymentMethodList';
import UpdatePaymentMethod from '../../components/payment/UpdatePaymentMethod';
import { useTranslation } from 'react-i18next';

const PaymentMethodSettings = ({ financeApiBaseUrl }) => {
    const [t] = useTranslation('global');
    const { currentTenantId, currentCompanyId, currentBranchId, userId, currentLangList, currentLangId } = useCurrent();
    const { data: paymentMethods, loading, refreshHandler } = useFetch(
        `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
    );
    const { data: dataCreate, loading: loadingCreate, postData: postCreate } = usePost();
    const { data: dataUpdate, loading: loadingUpdate, putData } = usePut();
    const { data: dataDelete, deleteItem, loading: loadingDelete } = useDelete();
    const [itemSelected, setItemSelected] = useState({});
    const [isConfirmDelete, setIsConfirmDelete] = useState(false);
    const [mode, setMode] = useState('Adding');

    useEffect(() => {
        if (dataCreate || dataUpdate || dataDelete) {
            refreshHandler();
            setMode('Adding');
        }
    }, [dataCreate, dataUpdate, dataDelete, refreshHandler]);

    const confirmDeleteHandler = (item) => {
        setItemSelected(item);
        setIsConfirmDelete(true);
    };

    const deleteHandler = () => {
        const id = itemSelected?.id;
        const url = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/delete/${id}`;
        deleteItem(url);
        setIsConfirmDelete(false);
    };

    const editHandler = (item) => {
        setItemSelected(item);
        setMode('Editing');
    };

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">{t('settings.paymentMethodSettings')}</h1>
            </div>
            <ConfirmDelete
                onShow={isConfirmDelete}
                setOnShow={setIsConfirmDelete}
                title={t('common.delete', 'حذف')}
                msg={t('settings.confirmDeletePaymentMethod')}
                onDeleteHandler={deleteHandler}
                loading={loadingDelete}
            />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1 bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    {loading ? <MwSpinner /> : (
                        mode === 'Adding' ? <CreatePaymentMethod
                            currentLangList={currentLangList}
                            currentTenantId={currentTenantId}
                            currentCompanyId={currentCompanyId}
                            currentBranchId={currentBranchId}
                            currentLangId={currentLangId}
                            userId={userId}
                            data={dataCreate}
                            loading={loadingCreate}
                            postData={postCreate}
                            showTreasury={true}
                            financeApiBaseUrl={financeApiBaseUrl}
                        /> : <UpdatePaymentMethod
                            currentLangList={currentLangList}
                            currentTenantId={currentTenantId}
                            currentCompanyId={currentCompanyId}
                            currentBranchId={currentBranchId}
                            currentLangId={currentLangId}
                            userId={userId}
                            currentItem={itemSelected}
                            data={dataUpdate}
                            loading={loadingUpdate}
                            putData={putData}
                            showTreasury={true}
                            financeApiBaseUrl={financeApiBaseUrl}
                        />
                    )}
                </div>
                <div className="lg:col-span-2">
                    {!!paymentMethods ? <PaymentMethodList
                        confirmDeleteHandler={confirmDeleteHandler}
                        editHandler={editHandler}
                        data={paymentMethods}
                        loading={loading}
                        currentLangId={currentLangId}
                    /> : <div className='h-40 bg-white p-6 rounded-lg shadow-sm border border-gray-200 flex items-center justify-center'> <MwSpinner hightScreen={false} />  </div>}
                </div>
            </div>
        </div>
    );
};

export default PaymentMethodSettings;
